(() => {
  if (window.__AQUAPHORIA_V4_WATER_WAKE__) return;
  window.__AQUAPHORIA_V4_WATER_WAKE__ = true;

  const doc = document;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(pointer: fine)');

  const removeWakes = () => {
    doc.querySelectorAll('.aq-v4-water-cursor, .aq-v4-water-wake, .aq-v4-water-trail').forEach((wake) => wake.remove());
  };

  const bindHero = (hero) => {
    if (!hero || hero.dataset.aqV4WakeBound === 'true') return;
    hero.dataset.aqV4WakeBound = 'true';

    const cursor = doc.createElement('span');
    cursor.className = 'aq-v4-water-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    hero.appendChild(cursor);

    let lastX = Number.NEGATIVE_INFINITY;
    let lastY = Number.NEGATIVE_INFINITY;
    let lastAt = 0;
    let lastLocalX = Number.NEGATIVE_INFINITY;
    let lastLocalY = Number.NEGATIVE_INFINITY;

    hero.addEventListener('pointermove', (event) => {
      if (reduced.matches || !finePointer.matches) return;
      if (event.pointerType && event.pointerType !== 'mouse') return;

      const bounds = hero.getBoundingClientRect();
      const localX = event.clientX - bounds.left;
      const localY = event.clientY - bounds.top;
      const pctX = Math.max(0, Math.min(100, (localX / Math.max(bounds.width, 1)) * 100));
      const pctY = Math.max(0, Math.min(100, (localY / Math.max(bounds.height, 1)) * 100));

      hero.style.setProperty('--aq-v4-cursor-x', `${pctX.toFixed(2)}%`);
      hero.style.setProperty('--aq-v4-cursor-y', `${pctY.toFixed(2)}%`);
      cursor.style.setProperty('--aq-v4-water-x', `${localX}px`);
      cursor.style.setProperty('--aq-v4-water-y', `${localY}px`);
      cursor.classList.add('is-active');

      const now = performance.now();
      if (now - lastAt < 62) return;

      const dx = event.clientX - lastX;
      const dy = event.clientY - lastY;
      if ((dx * dx) + (dy * dy) < 256) return;

      if (Number.isFinite(lastLocalX) && Number.isFinite(lastLocalY)) {
        const trailDx = localX - lastLocalX;
        const trailDy = localY - lastLocalY;
        const trailDistance = Math.hypot(trailDx, trailDy);
        if (trailDistance <= 220) {
          const trail = doc.createElement('span');
          trail.className = 'aq-v4-water-trail';
          trail.setAttribute('aria-hidden', 'true');
          trail.style.left = `${lastLocalX}px`;
          trail.style.top = `${lastLocalY}px`;
          trail.style.width = `${trailDistance.toFixed(1)}px`;
          trail.style.setProperty('--aq-v4-trail-angle', `${Math.atan2(trailDy, trailDx)}rad`);
          hero.appendChild(trail);
          const trails = hero.querySelectorAll('.aq-v4-water-trail');
          if (trails.length > 5) trails[0].remove();
          trail.addEventListener('animationend', () => trail.remove(), { once: true });
        }
      }

      const wake = doc.createElement('span');
      wake.className = 'aq-v4-water-wake';
      wake.setAttribute('aria-hidden', 'true');
      wake.style.left = `${localX}px`;
      wake.style.top = `${localY}px`;
      hero.appendChild(wake);

      const active = hero.querySelectorAll('.aq-v4-water-wake');
      if (active.length > 6) active[0].remove();

      wake.addEventListener('animationend', () => wake.remove(), { once: true });
      lastX = event.clientX;
      lastY = event.clientY;
      lastLocalX = localX;
      lastLocalY = localY;
      lastAt = now;
    }, { passive: true });

    hero.addEventListener('pointerleave', () => {
      cursor.classList.remove('is-active');
      lastX = Number.NEGATIVE_INFINITY;
      lastY = Number.NEGATIVE_INFINITY;
      lastLocalX = Number.NEGATIVE_INFINITY;
      lastLocalY = Number.NEGATIVE_INFINITY;
    }, { passive: true });
  };

  const boot = (scope = doc) => {
    if (reduced.matches || !finePointer.matches) return;
    if (scope.matches?.('.aq-v4-hero')) bindHero(scope);
    scope.querySelectorAll?.('.aq-v4-hero').forEach(bindHero);
  };

  const refresh = () => {
    if (reduced.matches || !finePointer.matches) {
      removeWakes();
      return;
    }
    boot(doc);
  };

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', () => boot(doc), { once: true });
  } else {
    boot(doc);
  }

  doc.addEventListener('shopify:section:load', (event) => boot(event.target));
  reduced.addEventListener?.('change', refresh);
  finePointer.addEventListener?.('change', refresh);
})();
